<template>
  <div>
    <b-form>
      <b-card title="Licencja" class="title-inline">
        <b-card-text>
          <b-row class="mb-3">
            <b-col lg="auto" class="mr-1 py-2">
              <b-row>
                <b-col lg="auto" class="mt-1 pr-1">Numer licencji</b-col>
                <b-col lg="auto" class="mt-1 p-lg-0"
                  ><span class="readonlyInput px-2 py-1">{{
                    client.LIC
                  }}</span></b-col
                >
              </b-row>
            </b-col>
            <b-col lg="auto" class="mr-1 py-2">
              <b-row>
                <b-col lg="auto" class="mt-1 pr-1">Wariant programu</b-col>
                <b-col lg="auto" class="mt-1 p-lg-0"
                  ><span class="readonlyInput px-2 py-1">{{
                    variant
                  }}</span></b-col
                >
              </b-row>
            </b-col>
            <b-col lg="auto" class="mr-1 py-2">
              <b-row>
                <b-col lg="auto" class="mt-1 pr-1">
                  <a
                    href="https://docs.format.wroc.pl/skp/Umowa_licencyjna_programu_SKP.pdf"
                    target="_blank"
                    class="info-text text-decoration-none"
                    >Umowa licencyjna programu SKP ></a
                  >
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mb-3" v-if="wasTransferredToSkp">
            <b-col lg="auto" class="mr-1 py-0 py-lg-2 mt-1 color-red-dark"
              >Dokonano przejścia na SKP®, dane przeniesione zostały do nowego
              programu.
            </b-col>
          </b-row>
          <b-row class="mb-3" v-else>
            <b-col lg="auto" class="mr-1 py-0 py-lg-2 mt-1"
              >Wersja {{ program.toUpperCase() }} {{ yearVersion }}
            </b-col>
            <b-col
              v-if="!isTestAccountUnregistered && !isTestAccountRegistered"
              lg="auto"
              class="mr-1 py-2"
            >
              <b-row>
                <b-col lg="auto" class="mt-1 pr-1">Posiadana</b-col>
                <b-col lg="auto" class="mt-1 p-lg-0"
                  ><span
                    class="px-2 py-1"
                    :class="{
                      redBorderInput: currentOs && !versionsIdentical,
                      readonlyInput: !currentOs || versionsIdentical,
                    }"
                    v-html="version"
                  ></span
                ></b-col>
              </b-row>
            </b-col>
            <b-col lg="auto" class="py-2 mx-0">
              <b-row>
                <b-col lg="auto" class="mt-1 pr-1">Dostępna</b-col>
                <b-col lg="auto" class="mt-1 p-lg-0 mr-1"
                  ><span
                    class="readonlyInput px-2 py-1"
                    :class="{
                      redNrDateInput: !versionsIdentical,
                    }"
                    v-html="availableVersion"
                  ></span
                ></b-col>
              </b-row>
            </b-col>
            <b-col lg="auto" class="py-2 mx-0">
              <b-row>
                <b-col
                  lg="auto"
                  md="auto"
                  class="px-1 mt-2 mt-lg-0 ml-2 mt-lg-0"
                >
                  <b-button
                    v-if="
                      currentOs &&
                      !showVersionsIdenticalInfo &&
                      !versionsIdentical &&
                      !isTestAccountUnregistered
                    "
                    size="sm"
                    class="mx-1 btn-accept-color"
                    @click.prevent="getUpdateProgram"
                    ref="submit"
                    >Pobierz najnowszą wersję
                  </b-button>
                  <span
                    v-if="
                      !currentOs &&
                      (isTestAccountUnregistered || isTestAccountRegistered)
                    "
                    class="info-text"
                  >
                    Uwaga! Nastąpiła zmiana roku. Pracujesz na nieaktualnej
                    wersji programu! Masz 2 możliwości:<br />
                    1)Testujesz program dalej na wersji z {{ year - 1 }} roku,
                    ale niektóre operacje będą niezgodne z najnowszymi
                    przepisami.<br />
                    2) Zdecydowałeś się na zakup programu SKP. W tym celu
                    kliknij zakładkę: Zamów SKP i zamów najnowszy program. Po
                    opłaceniu zamówienia otrzymasz program w wersji na rok
                    {{ year }}.<br />
                  </span>
                  <span
                    v-else-if="!currentOs && new Date().getMonth() + 1 === 12"
                    class="info-text"
                  >
                    Uwaga! Pracujesz na nieaktualnej wersji programu! <br />
                    Zamówienie Opieki Serwisowej na nowy rok, będzie możliwe od
                    01.01.{{ year }} r. bezpośrednio w zakładce: <br />Opieka
                    Serwisowa {{ year }}. Zapraszamy!
                  </span>
                  <span
                    v-else-if="!currentOs && new Date().getMonth() + 1 !== 12"
                    class="info-text"
                  >
                    Uwaga! Pracujesz na nieaktualnej wersji programu!
                    <br />Przejdź do zakładki Opieka Serwisowa {{ year }}<br />
                    i zamów dostęp do aktualizacji.
                    <span v-html="availableVersion"></span>
                  </span>

                  <span v-else-if="versionsIdentical" class="info-text"
                    >Posiadasz najnowszą wersję.</span
                  >
                  <b-modal
                    v-model="showVersionsIdenticalInfo"
                    id="modalPopover"
                    size="sm"
                    class="customModal"
                    @hide="!showVersionsIdenticalInfo"
                  >
                    <p>
                      Sprawdziliśmy, że Twoja wersja
                      {{ program.toUpperCase() }} jest aktualna i nie musisz
                      pobierać najnowszej wersji.
                    </p>
                    <p>Zamknij okno i korzystaj z programu bez obaw.</p>
                  </b-modal>
                </b-col>
              </b-row>
              <b-row
                v-if="
                  isNetworkVersion &&
                  currentOs &&
                  !showVersionsIdenticalInfo &&
                  !versionsIdentical
                "
              >
                <b-col lg="auto" class="maxWidth450 mt-2"
                  ><span class="text-danger"
                    >Uwaga! Aktualizując program pamiętaj, aby cały proces
                    został przeprowadzony na serwerze przy wyłączonym programie
                    SKP na stacjach roboczych.</span
                  ></b-col
                >
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="1" class="pr-0"> Posiadane moduły</b-col>
            <b-col lg="5">
              <Modules
                :checkedModules="checkedModules"
                :checkedAdds="checkedAdds"
                :isAccountant="isAccountant"
                :checkIcon="checkIcon"
                :xIcon="xIcon"
              ></Modules>
            </b-col>
            <b-col v-if="!isLimitedVersion" lg="1" class="pr-0">
              Posiadane dodatki
            </b-col>
            <b-col v-if="!isLimitedVersion" lg="5">
              <Adds
                v-if="checkedAdds"
                :checkedModules="checkedModules"
                :checkedAdds="checkedAdds"
                :isAccountant="isAccountant"
                :isLimitedVersion="isLimitedVersion"
                :year="year"
                :checkIcon="checkIcon"
                :xIcon="xIcon"
                :hasLimitedVersions="
                  clientOriginal.children &&
                  typeof clientOriginal.children !== undefined &&
                  clientOriginal.children.length > 0
                "
              ></Adds>
            </b-col>
          </b-row>
          <b-row class="mt-2" v-if="isAccountant">
            <b-col lg="auto" class="pr-0">
              <div class="float-left">
                <span>
                  <img
                    v-if="isAccountant"
                    :src="checkIcon"
                    alt="check"
                    class="pb-1"
                  />
                  <img v-else :src="xIcon" alt="check" class="pb-1" />
                </span>
                <label class="mr-2" :class="{ 'disabled-label': !isAccountant }"
                  >Biuro</label
                >
              </div>
            </b-col>
            <b-col lg="5">
              <span class="mr-2 float-left">Pakiet:</span>
              <div
                v-for="(option, index) in bOptions"
                :key="index"
                class="float-left"
              >
                <span>
                  <img
                    v-if="index == client.B_level"
                    :src="checkIcon"
                    alt="check"
                    class="pb-1"
                  />
                  <img v-else :src="xIcon" alt="check" class="pb-1" />
                </span>
                <label
                  class="mr-2"
                  :class="{
                    'disabled-label': index != client.B_level,
                  }"
                  >{{ option }}</label
                >
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2" v-if="!isAccountant && program === 'skp'">
            <b-col lg="auto" class="pr-0">
              <div class="float-left">
                <span>
                  <img :src="checkIcon" alt="check" class="pb-1" />
                </span>
                <label class="mr-2"
                  >Liczba obsługiwanych firm:
                  <span v-if="client.SPR < '2021-12-01'">3 firmy</span>
                  <span v-else>1 firma</span>
                </label>
              </div>
            </b-col>
          </b-row>
          <b-row
            class="mt-2"
            v-if="
              program === 'skp' &&
              (!isTestAccountRegistered || !isTestAccountUnregistered)
            "
          >
            <b-col lg="auto" class="pr-0">
              <div class="float-left">
                <span>
                  <img
                    v-if="hasCourseAccess"
                    :src="checkIcon"
                    alt="check"
                    class="pb-1"
                  />
                  <img v-else :src="xIcon" alt="check" class="pb-1" />
                </span>
                <label class="mr-2"
                  >Certyfikowany Kurs Obsługi SKP<sup>®</sup>
                </label>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2" v-if="program === 'skp'">
            <b-col lg="auto" class="pr-0">
              <div class="float-left">
                <span>
                  <img
                    v-if="clientHasP"
                    :src="checkIcon"
                    alt="check"
                    class="pb-1"
                  />
                  <img v-else :src="xIcon" alt="check" class="pb-1" />
                </span>
                <label class="mr-2" :class="{ 'disabled-label': !clientHasP }"
                  >Płace i ZUS</label
                >
              </div>
            </b-col>
            <b-col lg="5">
              <span class="mr-2 float-left">Pakiet:</span>
              <div
                v-for="(option, index) in pOptions"
                :key="index"
                class="float-left"
              >
                <span>
                  <img
                    v-if="index == client.P_level"
                    :src="checkIcon"
                    alt="check"
                    class="pb-1"
                  />
                  <img v-else :src="xIcon" alt="check" class="pb-1" />
                </span>
                <label
                  class="mr-2"
                  :class="{
                    'disabled-label': index != client.P_level,
                  }"
                  >{{ option }}</label
                >
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col lg="auto" class="pr-0">
              <div class="float-left">
                <span>
                  <img
                    v-if="cloudForCurrentYear"
                    :src="checkIcon"
                    alt="check"
                    class="pb-1"
                  />
                  <img v-else :src="xIcon" alt="check" class="pb-1" />
                </span>
                <label
                  class="mr-2"
                  :class="{ 'disabled-label': !cloudForCurrentYear }"
                  >{{ cloudTitle }}</label
                >
              </div>
            </b-col>
            <b-col lg="auto">
              <span class="mr-2">Abonament:</span>
              <div class="float-right">
                <span>
                  <img
                    v-if="cloudPeriod === 'yearly' && cloudPeriod !== 'monthly'"
                    :src="checkIcon"
                    alt="check"
                    class="pb-1"
                  />
                  <img v-else :src="xIcon" alt="check" class="pb-1" />
                </span>
                <label
                  class="mr-2"
                  :class="{
                    'disabled-label':
                      (cloudPeriod !== 'yearly' && cloudPeriod === 'monthly') ||
                      !cloudPeriod,
                  }"
                  >Roczny</label
                >
              </div>
              <div class="float-right">
                <span>
                  <img
                    v-if="cloudPeriod !== 'yearly' && cloudPeriod === 'monthly'"
                    :src="checkIcon"
                    alt="check"
                    class="pb-1"
                  />
                  <img v-else :src="xIcon" alt="check" class="pb-1" />
                </span>
                <label
                  class="mr-2"
                  :class="{
                    'disabled-label':
                      (cloudPeriod === 'yearly' && cloudPeriod !== 'monthly') ||
                      !cloudPeriod,
                  }"
                  >Miesięczny</label
                >
              </div>
            </b-col>
            <b-col lg="5" v-if="isAccountant">
              <span class="mr-2 float-left">Pakiet:</span>
              <div
                v-for="(plan, index) in availableCloudPlans"
                :key="index"
                class="float-left"
              >
                <span>
                  <img
                    v-if="index == cloudPlan"
                    :src="checkIcon"
                    alt="check"
                    class="pb-1"
                  />
                  <img v-else :src="xIcon" alt="check" class="pb-1" />
                </span>
                <label
                  class="mr-2"
                  :class="{
                    'disabled-label': index != cloudPlan,
                  }"
                  >{{ plan }}</label
                >
              </div>
            </b-col>
          </b-row>
          <b-row v-if="cloudPeriod !== 'yearly' && cloudPeriod === 'monthly'">
            <b-col offset-lg="2">
              <div v-for="(month, key) in months" :key="key" class="float-left">
                <span>
                  <img
                    v-if="cloudMonths.includes(Number(key))"
                    :src="checkIcon"
                    alt="check"
                    class="pb-1"
                  />
                  <img v-else :src="xIcon" alt="check" class="pb-1" />
                </span>
                <label
                  class="mr-2"
                  :class="{
                    'disabled-label': !cloudMonths.includes(Number(key)),
                  }"
                  >{{ month }}</label
                >
              </div>
            </b-col>
          </b-row>
          <b-row
            v-if="
              (clientOriginal.parent ||
                (typeof clientOriginal.children !== 'undefined' &&
                  clientOriginal.children &&
                  clientOriginal.children.length > 0)) &&
              !isTestAccountUnregistered &&
              !isTestAccountRegistered
            "
            class="mt-2"
          >
            <b-col lg="auto" class="pr-0">
              <div class="float-left">
                <span>
                  <img :src="checkIcon" alt="check" class="pb-1" />
                </span>
                <span v-if="clientOriginal.children"
                  >Współpracujące wersje ograniczone: {{ children }}</span
                >
                <span v-if="clientOriginal.parent">
                  Współpracujące Biuro: {{ clientOriginal.parent }}
                </span>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2" v-if="client.serviceKey">
            <b-col lg="auto" class="pr-0">
              <div class="float-left">
                <span>
                  <img :src="checkIcon" alt="check" class="pb-1" />
                </span>
                <span
                  >Hasło korektora zapisów księgowych:
                  <span v-if="currentOs" v-html="client.serviceKey"></span>
                  <span v-else>
                    Kup Opiekę Serwisową na {{ year }} rok, aby zobaczyć Hasło
                  </span>
                </span>
              </div>
            </b-col>
          </b-row>
          <b-row class="my-2" v-if="client.code">
            <b-col lg="auto" class="pr-0">
              <div class="float-left">
                <span>
                  <img :src="checkIcon" alt="check" class="pb-1" />
                </span>
                <span
                  >Kod rejestracyjny:
                  <span v-if="currentOs" v-html="client.code"></span>
                  <span v-else
                    >Kup Opiekę Serwisową na {{ year }} rok, aby zobaczyć
                    Kod</span
                  ></span
                >
              </div>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
      <b-row
        v-if="
          !isTestAccountUnregistered &&
          !isTestAccountRegistered &&
          !wasTransferredToSkp
        "
      >
        <b-col lg="12" class="font-italic info-text mt-2">
          <i class="fas fa-exclamation-circle"></i>
          Uwaga! Przycisk "Chce przenieść licencję na inny podmiot" dotyczy
          wyłącznie sytuacji, kiedy chcesz przekazać swoją licencję innemu
          podmiotowi.
          <span v-if="program === 'sam'">
            Opcja dostępna wyłącznie po przejściu na program SKP<sup>®</sup>.
          </span>
        </b-col>
      </b-row>
      <b-card
        v-if="!isTestAccountUnregistered && !wasTransferredToSkp"
        title="Dane firmy"
        class="title-inline"
      >
        <b-card-text>
          <b-row>
            <b-col lg="12" xl="2">
              <b-form-group label-cols-lg="auto" label="NIP" label-for="nip">
                <b-form-input
                  id="nip"
                  readonly
                  v-model="client.NIP"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="12" xl="4" v-if="!isTestAccountRegistered">
              <router-link
                v-if="program === 'skp'"
                :to="{
                  name: 'OrderChangeLicence',
                }"
                tag="button"
                class="btn mt-1 update-licence move-licence-btn btn-secondary"
                >Chcę przenieść licencję na inny podmiot
              </router-link>
              <b-button
                class="update-licence move-licence-btn"
                v-else
                @click.prevent="showTransferWarning = true"
                >Chcę przenieść licencję na inny podmiot
              </b-button>

              <b-modal
                v-model="showTransferWarning"
                id="modalPopover"
                size="lg"
                class="customModal"
                @hide="!showTransferWarning"
              >
                <p>
                  Opcja dostępna wyłącznie po przejściu na program
                  SKP<sup>®</sup>.
                </p>
                <p>
                  Aby skorzystać: Uruchom program SAM<sup>®</sup>, kliknij w
                  oknie komunikatu: „TAK! Przenieś mnie do SKP<sup>®</sup>” i w
                  Moim Koncie SKP<sup>®</sup> dokonaj przeniesienia danych
                  licencyjnych.
                  <a
                    href="https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/sam-zmiana-na-skp"
                    target="_blank"
                    >Czytaj więcej></a
                  >
                </p>
              </b-modal>
              <span
                id="tooltip-target-1"
                @mouseenter="toggleTooltipFocus()"
                @mouseleave="toggleTooltipFocus()"
                class="checkboxPointer"
              >
                <img
                  v-if="tooltipFocus"
                  :src="infoIconFocus"
                  alt="check"
                  class="pb-1"
                />
                <img v-else :src="infoIcon" alt="check" class="pb-1" />
              </span>
              <b-tooltip
                target="tooltip-target-1"
                triggers="hover"
                variant="secondary"
              >
                <p>
                  Zmiana numeru NIP związana jest ze zmianą właściciela
                  programu, a tym samym z przeniesieniem Licencji na nowego
                  Użytkownika. Jest to usługa płatna.
                </p>
                <p>
                  Przeniesienia Licencji dokonuje producent programu
                  wprowadzając NIP i dane nowego Użytkownika.
                </p>
                <p>
                  Wymagane jest podpisanie przez dotychczasowego Licencjobiorcę
                  „Oświadczenia o przeniesieniu licencji” i załączenie skanu.
                </p>
                <p>
                  Zmiana licencji przebiega w kilku prostych krokach.
                  Zapraszamy.
                </p>
              </b-tooltip>
            </b-col>
            <b-col lg="12" xl="6">
              <b-form-group
                label-cols-lg="auto"
                label="Nagłówek"
                label-for="header"
              >
                <b-form-input
                  id="header"
                  name="header"
                  v-model="client.NAG"
                  :disabled="!currentOs"
                  :state="validateHeader"
                  aria-describedby="header-feedback"
                ></b-form-input>
                <b-form-invalid-feedback id="header-feedback">
                  Niepoprawna ilość lub powtarzające się znaki
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
      <b-row v-if="!isTestAccountUnregistered && !isTestAccountRegistered">
        <b-col lg="12" class="font-italic info-text mt-2">
          <i class="fas fa-exclamation-circle"></i>
          Sprawdź swoje dane adresowe. Jeżeli zmieniły się to wpisz aktualne
          dane a pojawi się przycisk Zapisz zmianę danych.
        </b-col>
      </b-row>
      <b-card
        v-if="!isTestAccountUnregistered"
        title="Dane adresowe"
        class="last-card title-inline"
      >
        <b-card-text
          v-if="
            false &&
            !currentOs &&
            !this.isTestAccountRegistered &&
            !this.isTestAccountUnregistered
          "
        >
          <span class="font-italic info-text">
            <i class="fas fa-exclamation-circle"></i>
            Kup Opiekę Serwisową na {{ year }} rok, aby zmienić dane.</span
          >
          <router-link
            :to="{
              name: 'Order',
            }"
            tag="button"
            class="btn mt-1 update-licence btn-color btn-secondary btn-sm"
            >Kup Opiekę Serwisową
          </router-link>
        </b-card-text>
        <b-card-text v-if="isClient">
          <b-row>
            <b-col lg="6" class="border-solid-right">
              <b-form-group
                label-cols-lg="2"
                label="Nazwa"
                label-for="name1"
                class="label-width"
              >
                <b-form-input
                  id="name1"
                  v-model="client.N1"
                  :disabled="!currentOs"
                  :state="validateClientName1"
                  aria-describedby="nip-feedback"
                  autocomplete="off"
                ></b-form-input>
                <b-form-invalid-feedback id="name1-feedback">
                  Max. 54 znaki
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                label-cols-lg="2"
                label="Nazwa c.d"
                label-for="name2"
              >
                <b-form-input
                  id="name2"
                  v-model="client.N2"
                  :disabled="!currentOs"
                  :state="validateClientName2"
                  aria-describedby="name2-feedback"
                  autocomplete="off"
                ></b-form-input>
                <b-form-invalid-feedback id="name2-feedback">
                  Max. 54 znaki
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                label-cols-lg="auto"
                label="Adres"
                label-for="address"
              >
                <b-form-input
                  name="address"
                  id="address"
                  v-model="client.AD"
                  :disabled="!currentOs"
                  :state="validateClientAddress"
                  aria-describedby="address-feedback"
                  autocomplete="off"
                >
                </b-form-input>
                <b-form-invalid-feedback id="address-feedback">
                  Max. 35 znaków
                </b-form-invalid-feedback>
              </b-form-group>
              <b-row>
                <b-col lg="5" class="postalCode">
                  <b-form-group
                    label-cols-lg="auto"
                    label="Kod pocztowy"
                    label-for="postalCode"
                  >
                    <b-form-input
                      id="postalCode"
                      name="postalCode"
                      v-model="client.KOD"
                      v-mask="'##-###'"
                      :disabled="!currentOs"
                      :state="validateClientPostalCode"
                      aria-describedby="postalCode-feedback"
                      autocomplete="off"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback id="postalCode-feedback">
                      Max. 6 znaków
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col lg="7" class="city">
                  <b-form-group
                    label-cols-lg="auto"
                    label="Miejscowość"
                    label-for="city"
                  >
                    <b-form-input
                      id="city"
                      name="city"
                      v-model="client.MI"
                      :disabled="!currentOs"
                      :state="validateClientCity"
                      aria-describedby="city-feedback"
                      autocomplete="off"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback id="city-feedback">
                      Max. 20 znaków
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group
                label-cols-lg="auto"
                label="Siedziba"
                label-for="headquarters"
              >
                <b-form-input
                  id="headquarters"
                  name="headquarters"
                  v-model="client.SIE"
                  :disabled="!currentOs"
                  :state="validateClientHeadquarters"
                  aria-describedby="headquarters-feedback"
                  autocomplete="off"
                >
                </b-form-input>
                <b-form-invalid-feedback id="headquarters-feedback">
                  Max. 20 znaków
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col lg="6">
              <b-form-group
                label-cols-lg="auto"
                label="Osoba do kontaktu"
                label-for="contactPerson"
              >
                <b-form-input
                  name="contactPerson"
                  id="contactPerson"
                  v-model="client.O1"
                  :disabled="
                    isTestAccountRegistered || isTestAccountUnregistered
                  "
                  :state="validateClientContactPerson"
                  aria-describedby="contactPerson-feedback"
                  autocomplete="off"
                ></b-form-input>
                <b-form-invalid-feedback id="contactPerson-feedback">
                  Max. 30 znaków
                </b-form-invalid-feedback>
              </b-form-group>
              <b-row>
                <b-col lg="auto">
                  <b-form-group
                    label-cols-lg="auto"
                    label="Telefon"
                    label-for="phone1"
                  >
                    <b-form-input
                      type="number"
                      id="phone1"
                      name="phone1"
                      v-model="client.TEL1"
                      :disabled="
                        isTestAccountRegistered || isTestAccountUnregistered
                      "
                      :state="validateClientPhone1"
                      aria-describedby="nip-feedback"
                      autocomplete="off"
                      @keydown="validatePhone1($event)"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback
                      v-if="TEL1 && TEL1.toString().length > 11"
                      id="phone1-feedback"
                    >
                      Max. 11 znaków
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback
                      v-if="TEL1 && TEL1.toString().length < 9"
                      id="phone1-feedback"
                    >
                      Min. 9 znaków
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback
                      v-if="TEL1 && TEL1 <= 0"
                      id="phone1-feedback"
                    >
                      Wprowadź poprawny number telefonu
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col lg="3">
                  <b-form-input
                    id="phone2"
                    name="phone2"
                    type="number"
                    v-model="client.TEL2"
                    :disabled="
                      isTestAccountRegistered || isTestAccountUnregistered
                    "
                    :state="validateClientPhone2"
                    aria-describedby="phone2-feedback"
                    autocomplete="off"
                    @keydown="validatePhone2($event)"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback
                    v-if="TEL2 !== null && TEL2.toString().length > 11"
                    id="phone2-feedback"
                  >
                    Max. 11 znaków
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback
                    v-if="TEL2 !== null && TEL2.toString().length < 9"
                    id="phone2-feedback"
                  >
                    Min. 9 znaków
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback
                    v-else-if="TEL2 && TEL2 <= 0"
                    id="phone2-feedback"
                  >
                    Wprowadź poprawny numer telefonu
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback
                    v-else-if="TEL2 && TEL2 === TEL1"
                    id="phone2-feedback"
                  >
                    Masz już wpisany ten numer telefonu. Usuń go lub wpisz inny,
                    dodatkowy numer.
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
              <b-form-group
                label-cols-lg="auto"
                label="E-mail"
                label-for="email"
                class="group-no-margin"
              >
                <b-form-input
                  id="email"
                  v-model="client.E1"
                  :disabled="
                    isTestAccountRegistered || isTestAccountUnregistered
                  "
                  name="email"
                  :state="validateClientEmail"
                  aria-describedby="email-feedback"
                  autocomplete="off"
                >
                </b-form-input>
                <b-form-invalid-feedback id="email-feedback">
                  Nieprawidłowy email
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            ><p v-if="errors.length"></p>
            <ul>
              <li v-for="error in errors" :key="error" class="text-danger">
                {{ error }}
              </li>
            </ul>
          </b-row>
        </b-card-text>
      </b-card>
      <b-alert
        v-if="successAlert"
        v-model="successAlert"
        variant="success"
        dismissible
        class="my-1"
      >
        {{ message }}
      </b-alert>
      <b-alert
        v-if="failAlert"
        v-model="failAlert"
        variant="danger"
        dismissible
        class="my-1"
      >
        Błędy w formularzu.
      </b-alert>
      <b-row
        v-if="Object.keys(updatedData).length > 0 && !isTestAccountUnregistered"
        class="mt-2"
      >
        <b-button
          variant="secondary"
          class="ml-auto btn-color"
          @click.prevent="refreshClientData()"
          >Anuluj
        </b-button>
        <b-button
          variant="success"
          class="mx-3 btn-accept-color"
          @click.prevent="onSubmit"
          ref="submit"
          >Zapisz zmianę danych
        </b-button>
      </b-row>
      <b-overlay
        :show="confirm"
        no-wrap
        @shown="onShown"
        @hidden="onHidden"
        opacity="1"
      >
        <template #overlay>
          <div v-if="processing" class="text-center">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
          <div
            v-else
            ref="dialog"
            tabindex="-1"
            role="dialog"
            aria-modal="true"
            aria-labelledby="form-confirm-label"
            class="text-center mb-1"
          >
            <div v-if="Object.keys(updatedData).length > 0">
              <p class="text-left">Zmieniłeś dane licencyjne na:</p>
              <p class="text-left mb-1">
                Nazwa 1:
                <span
                  :class="{
                    'text-success': addSuccessClassToChanged(
                      'N1',
                      clientOriginal.N1,
                      N1
                    ),
                  }"
                  >{{ client.N1 }}</span
                >
              </p>
              <p class="text-left mb-1">
                Nazwa 2:
                <span
                  :class="{
                    'text-success': addSuccessClassToChanged(
                      'N2',
                      clientOriginal.N2,
                      N2
                    ),
                  }"
                  >{{ client.N2 }}</span
                >
              </p>
              <p class="text-left mb-1">
                Nagłówek:
                <span
                  :class="{
                    'text-success': addSuccessClassToChanged(
                      'NAG',
                      clientOriginal.NAG,
                      NAG
                    ),
                  }"
                  >{{ client.NAG }}</span
                >
              </p>
              <p class="text-left mb-1">
                Adres:
                <span
                  :class="{
                    'text-success': addSuccessClassToChanged(
                      'AD',
                      clientOriginal.AD,
                      AD
                    ),
                  }"
                  >{{ client.AD }}</span
                >
              </p>
              <p class="text-left mb-1">
                Kod pocztowy:
                <span
                  :class="{
                    'text-success': addSuccessClassToChanged(
                      'KOD',
                      clientOriginal.KOD,
                      KOD
                    ),
                  }"
                  >{{ client.KOD }}</span
                >
              </p>
              <p class="text-left mb-1">
                Miasto:
                <span
                  :class="{
                    'text-success': addSuccessClassToChanged(
                      'MI',
                      clientOriginal.MI,
                      MI
                    ),
                  }"
                  >{{ client.MI }}</span
                >
              </p>
              <p class="text-left mb-1">
                Siedziba:
                <span
                  :class="{
                    'text-success': addSuccessClassToChanged(
                      'SIE',
                      clientOriginal.SIE,
                      SIE
                    ),
                  }"
                  >{{ client.SIE }}</span
                >
              </p>
              <p class="text-left mb-1">
                Telefon 1:
                <span
                  :class="{
                    'text-success': addSuccessClassToChanged(
                      'TEL1',
                      clientOriginal.TEL1,
                      TEL1
                    ),
                  }"
                  >{{ TEL1 }}</span
                >
              </p>
              <p class="text-left mb-1">
                Telefon 2:
                <span
                  :class="{
                    'text-success': addSuccessClassToChanged(
                      'TEL2',
                      clientOriginal.TEL2,
                      TEL2
                    ),
                  }"
                  >{{ TEL2 }}</span
                >
              </p>
              <p class="text-left mb-1">
                Osoba do kontaktu:
                <span
                  :class="{
                    'text-success': addSuccessClassToChanged(
                      'O1',
                      clientOriginal.O1,
                      O1
                    ),
                  }"
                  >{{ client.O1 }}</span
                >
              </p>
              <p class="text-left">
                E-mail:
                <span
                  :class="{
                    'text-success': addSuccessClassToChanged(
                      'E1',
                      clientOriginal.E1,
                      E1
                    ),
                  }"
                  >{{ client.E1 }}</span
                >
              </p>
              <p>
                <strong id="form-confirm-label"
                  >Podmienić dane licencyjne?</strong
                >
              </p>
            </div>
            <div v-else class="mb-2">
              Nie zmieniłeś danych. Wprowadź zmiany a następnie kliknij Zapisz.
            </div>
            <div>
              <b-button
                variant="outline-danger"
                class="mr-3 btn-color"
                @click="onCancel"
              >
                Anuluj
              </b-button>
              <b-button
                class="btn-accept-color"
                variant="outline-success"
                @click="updateClient"
                v-if="Object.keys(updatedData).length > 0"
                >TAK
              </b-button>
            </div>
          </div>
        </template>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Modules from './partials/Modules';
import Adds from './partials/Adds';
import moment from 'moment';
import { accountant, company } from './config/cloud';

export default {
  name: 'Licence',
  components: { Modules, Adds },
  props: {
    styles: {},
    xIcon: {},
    checkIcon: {},
    infoIcon: {},
    infoIconFocus: {},
  },
  data() {
    return {
      clientOriginal: {},
      client: {},
      modules: [],
      adds: [],
      checkedModules: [],
      checkedAdds: [],
      errors: [],
      showTransferWarning: false,
      successAlert: false,
      failAlert: false,
      message: '',
      year: process.env.MIX_AKTU_YEAR,
      currentVersion: '',
      confirm: false,
      processing: false,
      cloudMonths: [],
      cloudPeriod: null,
      cloudPlan: null,
      months: {
        1: 'I',
        2: 'II',
        3: 'III',
        4: 'IV',
        5: 'V',
        6: 'VI',
        7: 'VII',
        8: 'VIII',
        9: 'IX',
        10: 'X',
        11: 'XI',
        12: 'XII',
      },
      tooltipFocus: false,
      showVersionsIdenticalInfo: false,
      updatedData: {},
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      licence: 'auth/userLicence',
      currentOs: 'auth/currentOs',
      wasTransferredToSkp: 'auth/wasTransferredToSkp',
      clientAuth: 'auth/client',
      isTestAccountRegistered: 'auth/isTestAccountRegistered',
      isTestAccountUnregistered: 'auth/isTestAccountunRegistered',

      hasCourseAccess: 'auth/hasCourseAccess',
    }),
    staffId() {
      return localStorage.getItem('staffId');
    },
    version() {
      let currentYear = 0;
      if (this.client.AKT !== '1899-12-30' && this.client.AKT !== null) {
        currentYear = moment(this.client.AKT, 'YYYY-MM-DD').format('YY');
      }

      for (let i = currentYear; i >= 11; --i) {
        if (this.client['WER_' + i]) {
          return (
            this.client['WER_' + i] +
            '  <span class="font-italic font-smaller">pobrana w dniu ' +
            moment(this.client['DATA_AKTU_' + i]).format('DD-MM-YYYY') +
            '</span>'
          );
        }
      }

      return '';
    },
    yearVersion() {
      let currentYear = 0;
      if (this.client.AKT !== '1899-12-30' && this.client.AKT !== null) {
        currentYear = moment(this.client.AKT, 'YYYY-MM-DD').format('YY');
      }
      for (let i = currentYear; i >= 11; --i) {
        if (this.client['WER_' + i]) {
          return moment(this.client['DATA_AKTU_' + i]).format('YYYY');
        }
      }
      return new Date().getFullYear();
    },
    availableVersion() {
      return this.currentVersion.Data_Kom
        ? this.currentVersion.NR_WERSJI +
            ' <span class="font-italic font-smaller"><span class="color-black">z dnia</span> ' +
            moment(this.currentVersion.Data_Kom).format('DD-MM-YYYY') +
            '</span>'
        : this.currentVersion.NR_WERSJI;
    },
    isClient() {
      return Object.keys(this.client).length > 0;
    },
    validateClientName1() {
      if (this.client.N1 !== null && this.client.N1 !== '') {
        return this.client.N1.length > 54 ? false : null;
      } else if (!this.client.N1 || this.client.N1 === '') {
        return false;
      }
      return null;
    },
    validateClientName2() {
      const regex =
        /[\+]?[(]?[0-9]{2,}[)]?[-\s\.]?[0-9]{2,}[-\s\.]?[0-9]{2,}[-\s\.]?[0-9]{0,}/gim;
      if (this.client.N2 !== null) {
        return this.client.N2.length > 54 ||
          regex.test(String(this.client.N2).toLowerCase())
          ? false
          : null;
      }
      return null;
    },
    validateHeader() {
      const regex = /(.)\1{2}/;

      if (this.client.NAG !== null && this.client.NAG !== '') {
        return this.client.NAG.length < 5 ||
          this.client.NAG.length > 50 ||
          regex.test(String(this.client.NAG).toLowerCase())
          ? false
          : null;
      } else if (!this.client.NAG || this.client.NAG === '') {
        return false;
      }
      return null;
    },
    validateClientPhone1() {
      if (this.TEL1 !== null && this.TEL1 !== '') {
        return this.TEL1.toString().length > 11 ||
          this.TEL1.toString().length < 9 ||
          this.TEL1 <= 0
          ? false
          : null;
      } else if (!this.TEL1 || this.TEL1 === '') {
        return false;
      }
      return null;
    },
    validateClientPhone2() {
      if (this.TEL2 !== null && this.TEL2 !== '') {
        return this.TEL2.toString().length > 11 ||
          this.TEL2.toString().length < 9 ||
          this.TEL2 <= 0 ||
          this.TEL2 === this.TEL1
          ? false
          : null;
      }
      return null;
    },
    validateClientContactPerson() {
      if (this.client.O1 !== null) {
        return this.client.O1.length > 30 ? false : null;
      }
      return null;
    },
    validateClientAddress() {
      if (this.client.AD !== null && this.client.AD !== '') {
        return this.client.AD.length > 35 ? false : null;
      } else if (!this.client.AD || this.client.AD === '') {
        return false;
      }
      return null;
    },
    validateClientPostalCode() {
      if (this.client.KOD !== null && this.client.KOD !== '') {
        return this.client.KOD.length !== 6 ? false : null;
      } else if (!this.client.KOD || this.client.KOD === '') {
        return false;
      }
      return null;
    },
    validateClientCity() {
      if (this.client.MI !== null && this.client.MI !== '') {
        return this.client.MI.length > 20 ? false : null;
      } else if (!this.client.MI || this.client.MI === '') {
        return false;
      }
      return null;
    },
    validateClientHeadquarters() {
      if (this.client.SIE !== null && this.client.SIE !== '') {
        return this.client.SIE.length > 20 ? false : null;
      } else if (!this.client.SIE || this.client.SIE === '') {
        return false;
      }
      return null;
    },
    validateClientEmail() {
      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,50}))$/;

      if (this.client.E1 !== null && this.client.E1 !== '') {
        return regex.test(String(this.client.E1).toLowerCase()) ? null : false;
      } else if (!this.client.E1 || this.client.E1 === '') {
        return false;
      }
      return null;
    },
    clientHasP() {
      return (
        this.client &&
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('P')
      );
    },
    cloudForCurrentYear() {
      return this.cloudMonths.length > 0;
    },
    isAccountant() {
      if (this.client && this.client.MDS !== null) {
        return this.client.MDS.split('').includes('B');
      }
      return false;
    },
    isLimitedVersion() {
      if (this.client && this.client.MDS !== null) {
        return this.client.MDS.split('').includes('O');
      }
      return false;
    },
    isNetworkVersion() {
      if (this.client && this.client.MDS !== null) {
        return this.client.MDS.split('').includes('S');
      }
      return false;
    },
    availableCloudPlans() {
      return { 5: 'Start', 10: 'Extra', 20: 'Komfort', 99: 'Premium' };
    },
    pOptions() {
      return { 1: 'do 3 osób', 2: 'do 20 osób', 3: 'bez limitu osób' };
    },
    bOptions() {
      return { 1: 'do 10 firm', 2: 'do 50 firm', 3: 'bez limitu firm' };
    },
    cloudTitle() {
      return this.isAccountant ? accountant.title : company.title;
    },
    N1() {
      return this.client.N1;
    },
    N2() {
      return this.client.N2;
    },
    NAG() {
      return this.client.NAG;
    },
    AD() {
      return this.client.AD;
    },
    KOD() {
      return this.client.KOD;
    },
    MI() {
      return this.client.MI;
    },
    SIE() {
      return this.client.SIE;
    },
    O1() {
      return this.client.O1;
    },
    E1() {
      return this.client.E1;
    },
    TEL1() {
      return this.client.TEL1;
    },
    TEL2() {
      return this.client.TEL2;
    },
    variant() {
      if (this.isTestAccountRegistered || this.isTestAccountUnregistered)
        return 'TEST';
      if (this.isAccountant)
        return this.client.MDS !== null &&
          this.client.MDS !== '' &&
          this.client.MDS.split('').includes('S')
          ? 'Wielostanowiskowa'
          : 'Biuro';
      if (this.isLimitedVersion) return 'Ograniczona';

      return this.program === 'skp' ? 'Firma' : 'Basic';
    },
    children() {
      let children = '';

      if (this.clientOriginal && this.clientOriginal.children) {
        this.clientOriginal.children.forEach(function (item) {
          children += item + ', ';
        });

        return children.slice(0, -2);
      }

      return children;
    },
    versionsIdentical() {
      return (
        this.client['WER_' + moment().format('YY')] ===
        this.currentVersion.NR_WERSJI
      );
    },
    linkForProgramDownload() {
      return this.program === 'skp'
        ? 'https://www.ksiega-podatkowa.pl/pobierz-najnowsza-wersje'
        : 'https://www.samozatrudnienie.pl/pobierz-najnowsza-wersje';
    },
  },
  created() {
    this.$store.commit('order/resetOrder');
    this.$store.commit('order/resetSteps');
    // this.$store.dispatch('auth/me');
    this.client = this.clientAuth;
    this.getClientData();
    this.getVersion();
    if (!this.isTestAccountRegistered && !this.isTestAccountUnregistered) {
      this.getCloudDataByClient();
    }
  },
  methods: {
    onSubmit() {
      this.errors = [];
      this.validateForm();
      if (this.errors.length === 0) {
        this.validateLength();
      }
      if (this.errors.length === 0) {
        this.confirm = true;
      }
    },
    onShown() {
      this.$refs.dialog.focus();
    },
    onHidden() {
      // TODO: submit is undefined
      if (this.$refs.submit) {
        this.$refs.submit.focus();
      }
    },
    onCancel() {
      this.confirm = false;
    },
    getClientData() {
      axios
        .get('/api/getClient/' + this.program)
        .then(({ data }) => {
          this.clientOriginal = data;
          if (data.MDS !== null && data.MDS !== '') {
            this.checkedModules = data.MDS.split('');
            if (this.checkedModules.includes('M') && !this.isAccountant) {
              this.checkedModules.push('F');
            }
          }
          if (data.DOD !== null && data.DOD !== '') {
            this.checkedAdds = data.DOD.split('');
          }
        })
        .catch((error) => {
          if (
            error.response &&
            (error.response.status === 401 || error.response.status === 419)
          ) {
            this.$store.dispatch('auth/me');
            this.$router.push({ name: 'Login' });
          }
        });
    },
    updateClient() {
      this.errors = [];
      this.processing = true;
      axios
        .post('/api/updateClient', {
          client: this.updatedData,
          id: this.licence,
          program: this.program,
          currentOs: this.currentOs,
          staffId: this.staffId,
        })
        .then((data) => {
          this.errors = [];
          this.processing = false;
          this.confirm = false;
          this.successAlert = true;
          this.message = data.data;
          this.failAlert = false;
          this.getClientData();
          this.updatedData = {};
        })
        .catch((error) => {
          this.processing = false;
          this.confirm = false;
          this.failAlert = true;
          this.successAlert = false;
          let that = this;

          $.each(error.response.data.errors, function (key, value) {
            if (value[0]) {
              that.errors.push(value[0]);
            }
          });
        });
    },
    refreshClientData() {
      this.client = Object.assign({}, this.clientOriginal);
      this.tel1 = null;
      this.tel2 = null;
      this.updatedData = {};
    },
    getVersion() {
      axios
        .get('/api/currentVersion/' + this.program)
        .then(({ data }) => {
          this.currentVersion = data;
        })
        .catch((error) => {});
    },
    getCloudDataByClient() {
      axios
        .get('/api/getCloudDataByClient/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          if (data.length > 0) {
            this.cloudPeriod = data.length === 12 ? 'yearly' : 'monthly';
            this.cloudMonths = data.map((item) => item.month);
            let isCloudPlanCurrentMonth = data.filter(
              (item) => item.month === moment().format('M')
            );
            if (isCloudPlanCurrentMonth.length > 0) {
              this.cloudPlan = isCloudPlanCurrentMonth[0];
            } else {
              this.cloudPlan = data[0].plan_limit;
            }
          }
        });
    },
    validateForm() {
      if (!this.client.N1) this.errors.push('Uzupełnij pole nazwa.');
      if (!this.client.NAG) this.errors.push('Uzupełnij pole nagłówek.');
      if (!this.client.AD) this.errors.push('Uzupełnij pole adres.');
      if (!this.client.KOD) this.errors.push('Uzupełnij pole kod pocztowy.');
      if (!this.client.MI) this.errors.push('Uzupełnij pole miasto.');
      if (!this.client.SIE) this.errors.push('Uzupełnij pole siedziba.');
      if (!this.client.TEL1) this.errors.push('Uzupełnij pole telefon.');
      if (!this.client.E1) this.errors.push('Uzupełnij pole e-mail.');
    },
    validateLength() {
      if (
        (typeof this.client.N1 === 'string' && this.client.N1.length > 54) ||
        (typeof this.client.N2 === 'string' && this.client.N2.length > 54) ||
        (typeof this.client.NAG === 'string' && this.client.NAG.length > 50) ||
        (this.TEL1 !== null &&
          (this.TEL1.toString().length < 9 || this.TEL1 < 0)) ||
        (this.TEL2 !== null &&
          this.TEL2 !== '' &&
          (this.TEL2.toString().length < 9 ||
            this.TEL2 < 0 ||
            this.TEL1 === this.TEL2)) ||
        (typeof this.client.O1 === 'string' && this.client.O1.length > 30) ||
        (typeof this.client.AD === 'string' && this.client.AD.length > 35) ||
        (typeof this.client.KOD === 'string' && this.client.KOD.length !== 6) ||
        (typeof this.client.MI === 'string' && this.client.MI.length > 20) ||
        (typeof this.client.SIE === 'string' && this.client.SIE.length > 20) ||
        (typeof this.client.E1 === 'string' && this.client.E1.length > 50)
      ) {
        this.errors = [
          'Masz wpisane za dużo lub za mało znaków, popraw dane i ponownie kliknij Zapisz.',
        ];
      } else {
        this.errors = [];
      }
    },
    toggleTooltipFocus() {
      this.tooltipFocus = !this.tooltipFocus;
    },

    getUpdateProgram() {
      axios.get('/api/getClient/' + this.program).then(({ data }) => {
        this.client = Object.assign({}, data);

        if (this.versionsIdentical) {
          this.showVersionsIdenticalInfo = true;
          this.downloading = false;
        } else {
          this.downloadProgram();
        }
      });
    },
    downloadProgram() {
      window.open(this.linkForProgramDownload);
    },
    addSuccessClassToChanged(field, oldName, newName) {
      if (oldName && newName) {
        let old =
          field === 'TEL1' || field === 'TEL2'
            ? parseInt(oldName.replace(/-|\s/g, '')).toString().trim()
            : oldName.toString().trim();

        return old !== newName.toString().trim();
      }
      if (!oldName && newName) {
        return true;
      }

      return false;
    },
    validatePhone1(e) {
      if (this.TEL1 && this.TEL1.toString().length >= 11 && e.keyCode !== 8) {
        e.preventDefault();
      }
    },
    validatePhone2(e) {
      if (this.TEL2 && this.TEL2.toString().length >= 11 && e.keyCode !== 8) {
        e.preventDefault();
      }
    },
  },
  watch: {
    N1() {
      if (this.clientOriginal.N1 !== undefined) {
        if (
          (this.clientOriginal.N1 &&
            this.N1.trim() !== this.clientOriginal.N1.trim()) ||
          (!this.clientOriginal.N1 && this.N1.trim())
        ) {
          this.updatedData.N1 = this.N1.trim();
        } else {
          delete this.updatedData.N1;
        }
      }
      this.validateLength();
    },
    N2() {
      if (this.clientOriginal.N2 !== undefined) {
        if (
          (this.clientOriginal.N2 &&
            this.N2.trim() !== this.clientOriginal.N2.trim()) ||
          (!this.clientOriginal.N2 && this.N2.trim())
        ) {
          this.updatedData.N2 = this.N2.trim();
        } else {
          delete this.updatedData.N2;
        }
      }
      this.validateLength();
    },
    NAG() {
      if (this.clientOriginal.NAG !== undefined) {
        if (
          (this.clientOriginal.NAG &&
            this.NAG.trim() !== this.clientOriginal.NAG.trim()) ||
          (!this.clientOriginal.NAG && this.NAG.trim())
        ) {
          this.updatedData.NAG = this.NAG.trim();
        } else {
          delete this.updatedData.NAG;
        }
      }
      this.validateLength();
    },
    AD() {
      if (this.clientOriginal.AD !== undefined) {
        if (
          (this.clientOriginal.AD &&
            this.AD.trim() !== this.clientOriginal.AD.trim()) ||
          (!this.clientOriginal.AD && this.AD.trim())
        ) {
          this.updatedData.AD = this.AD.trim();
        } else {
          delete this.updatedData.AD;
        }
        this.validateLength();
      }
    },
    KOD() {
      if (this.clientOriginal.KOD !== undefined) {
        if (
          (this.clientOriginal.KOD &&
            this.KOD.trim() !== this.clientOriginal.KOD.trim()) ||
          (!this.clientOriginal.KOD && this.KOD.trim())
        ) {
          this.updatedData.KOD = this.KOD.trim();
        } else {
          delete this.updatedData.KOD;
        }
      }
      this.validateLength();
    },
    MI() {
      if (this.clientOriginal.MI !== undefined) {
        if (
          (this.clientOriginal.MI &&
            this.MI.trim() !== this.clientOriginal.MI.trim()) ||
          (!this.clientOriginal.MI && this.MI.trim())
        ) {
          this.updatedData.MI = this.MI.trim();
        } else {
          delete this.updatedData.MI;
        }
      }
      this.validateLength();
    },
    SIE() {
      if (this.clientOriginal.SIE !== undefined) {
        if (
          (this.clientOriginal.SIE &&
            this.SIE.trim() !== this.clientOriginal.SIE.trim()) ||
          (!this.clientOriginal.SIE && this.SIE.trim())
        ) {
          this.updatedData.SIE = this.SIE.trim();
        } else {
          delete this.updatedData.SIE;
        }
      }
      this.validateLength();
    },
    O1() {
      if (this.clientOriginal.O1 !== undefined) {
        if (
          (this.clientOriginal.O1 &&
            this.O1.trim() !== this.clientOriginal.O1.trim()) ||
          (!this.clientOriginal.O1 && this.O1.trim())
        ) {
          this.updatedData.O1 = this.O1.trim();
        } else {
          delete this.updatedData.O1;
        }
      }
      this.validateLength();
    },
    TEL1() {
      if (this.clientOriginal.TEL1 !== undefined) {
        if (
          (this.clientOriginal.TEL1 &&
            this.TEL1 !== this.clientOriginal.TEL1 &&
            this.TEL1 > 0) ||
          (!this.clientOriginal.TEL1 && this.TEL1)
        ) {
          this.updatedData.TEL1 = this.TEL1;
        } else {
          delete this.updatedData.TEL1;
        }
      }
      this.validateLength();
    },
    TEL2() {
      if (this.clientOriginal.TEL2 !== undefined) {
        if (
          (this.clientOriginal.TEL2 &&
            this.TEL2 !== this.clientOriginal.TEL2 &&
            (this.TEL2 > 0 || !this.TEL2)) ||
          (!this.clientOriginal.TEL2 && this.TEL2)
        ) {
          this.updatedData.TEL2 = this.TEL2;
        } else {
          delete this.updatedData.TEL2;
        }
      }
      this.validateLength();
    },
    E1() {
      if (this.clientOriginal.E1 !== undefined) {
        if (
          (this.clientOriginal.E1 &&
            this.E1 !== this.clientOriginal.E1.trim()) ||
          (!this.clientOriginal.E1 && this.E1)
        ) {
          this.updatedData.E1 = this.E1;
        } else {
          delete this.updatedData.E1;
        }
      }
      this.validateLength();
    },
  },
};
</script>

<style lang="scss" scoped>
.border-solid-right {
  border-right: 1px solid;
}

.tooltip {
  opacity: 1 !important;
}

#postalCode {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.move-left {
  padding-left: 0;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}

.maxWidth450 {
  max-width: 450px;
}

::v-deep {
  @media only screen and (max-width: 1300px) {
    .city,
    .postalCode {
      width: 100% !important;
      position: relative;
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
}
</style>
